import { Skeleton, Tooltip, tableHelpers } from '@round/creatorbase-ui';
import { getRequestedOutputItems } from '../../../../../helpers';
import { ConfigurationItemGlyph } from '../../../../../components/ConfigurationItemBadge/ConfigurationItemBadge';
import { CellContext, getMeta, NO_VALUE } from '../../helpers';
import styles from './OutputsCell.module.css';

export const OutputsCell = ({ row: { original }, table }: CellContext) => {
    const { isLoading } = getMeta(table);

    if (tableHelpers.isLoadingRow(original) || isLoading) {
        return <Skeleton className={styles.skeleton} />;
    }

    const requestedItems = getRequestedOutputItems(original.outputs);

    // Every request returns the same two columns without asking, so one that asked for nothing more
    // has nothing here to tell it apart.
    if (!requestedItems.length) {
        return <span>{NO_VALUE}</span>;
    }

    return (
        <span className={styles.glyphs}>
            {requestedItems.map((item) => (
                <Tooltip key={item.key}>
                    {/* The cell is icons alone, so the label they stand for is named on the trigger
                        as well as in the tooltip. */}
                    <Tooltip.Trigger aria-label={item.label} className={styles.glyphTrigger}>
                        <ConfigurationItemGlyph icon={item.icon} />
                    </Tooltip.Trigger>

                    <Tooltip.Content>{item.label}</Tooltip.Content>
                </Tooltip>
            ))}
        </span>
    );
};
